/* eslint-disable no-underscore-dangle */
import Shepherd from 'shepherd.js';
import { ENABLE_TOUR_GUIDE } from '@/Utils/vice-constants';
import '../../css/shepherd.css';

const isElementVisible = () => true;
// const isElementVisible = (el) => {
//   if (el == null) return false;
//   if (el.tagName == 'HTML') return true; // Reached the top of the document
//   const style = window.getComputedStyle(el);
//   if (style.display === 'none') return false;
//   return isElementVisible(el.parentNode);
// };
class TourManager {
  constructor(tourName, steps, options = {}) {
    this.tourName = tourName;
    this.steps = steps;

    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      modalOverlayOpeningPadding: 16,
      modalOverlayOpeningRadius: 24,
      defaultStepOptions: {
        scrollTo: { behavior: 'smooth', block: 'center' },
        ...options,
      },
      steps: this.initSteps(steps),
    });
  }

  initSteps(steps = []) {
    const self = this;
    return steps.map((step, index) => ({
      ...step,
      showOn() {
        const element = document.querySelector(this.attachTo.element);
        return isElementVisible(element);
      },
      attachTo: step.attachTo || {},
      buttons: this._getButtons(index),
      when: {
        show: () => {
          self.updateCurrentStep(index);
        },
      },
    }));
  }

  _getButtons(index) {
    const self = this;
    const backButtonClasses = index === 0 ? 'opacity-50' : ' ';
    return [
      {
        action() {
          self.updateCurrentStep(index - 1);
          return this.back();
        },
        text: `<span class=" ${backButtonClasses} flex text-sm items-center gap-1  rounded-md bg-vice-rose-400 hover:bg-vice-rose-500 px-2 h-8"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="w-5" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /> </svg> Back</span>`,
      },
      {
        action() {
          self.updateCurrentStep(index + 1);
          return this.next();
        },
        text: '<span class="flex text-sm items-center gap-1  rounded-md bg-vice-rose-400 hover:bg-vice-rose-500 px-2 h-8">Next <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="w-5" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"> <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg></span>',
      },
      {
        action: () => {
          localStorage.setItem(`_vice:tour_skipped`, true);
          this.tour.complete();
        },
        text: 'Skip tour',
      },
    ];
  }

  startTour() {
    const tourSkipped = localStorage.getItem(`_vice:tour_skipped`);

    if (tourSkipped == null && ENABLE_TOUR_GUIDE) {
      const currentStep = localStorage.getItem(`_vice:${this.tourName}_current_step`);
      if (currentStep == null) {
        this.tour.start();
      } else if (this.steps[currentStep]) {
        this.tour.show(this.steps[currentStep].id);
      }
    }
  }

  cancelTour() {
    this.tour.cancel();
  }

  updateCurrentStep(currentStepIndex) {
    localStorage.setItem(`_vice:${this.tourName}_current_step`, Math.max(0, currentStepIndex));
  }
}

export default TourManager;
